import * as React from "react";
const autobind = require("class-autobind").default;
import styled from "../../../styled/index";
import darken from "polished/lib/color/darken";
import { CS } from "../../../styles/index";
import { BaseInputCSS } from "../input/index";
import { FaTimes } from "react-icons/fa";
export const TagTimes = styled("div") `
  display: flex;
  align-items: center;
  height: 100%;
  padding: 0 5px;
  //margin-left: 8px;
  cursor: pointer;
  background: ${({ theme }) => darken(0.07, theme.input.background)};
`;
export const Tag = styled("div") `
  display: flex;
  height: 24px;
  line-height: 24px;
  padding: 0 0 0 8px;
  background: ${({ theme }) => darken(0.12, theme.input.background)};
  border-radius: 5px;
  column-gap: 8px;
  overflow: hidden;
`;
export const TagLabel = styled("div") `
	padding-left: 8px;
	padding-right: ${(props) => props.hasPaddingRight ? '8px' : '0px'}
`;
export const Input = styled("input") `
  ${BaseInputCSS};
  border: none;
  width: auto;
  flex-grow: 1;
  height: 24px;
  line-height: normal;
  padding: 0 5px;
  &:focus {
    border: none !important;
  }
`;
export const Wrapper = styled("div") `
  ${BaseInputCSS};
  ${(props) => props.shadow ? CS.shadow.light[props.shadow] : ""};
  position: relative;
  display: flex;
  flex-wrap: wrap;
  height: auto;
  padding: 3px;
  > * {
    margin: 3px;
  }
`;
export class InputTags extends React.PureComponent {
    constructor(props) {
        super(props);
        autobind(this);
        this.state = {
            input: "",
        };
    }
    onEnter(e) {
        e.stopPropagation();
        if (e.key === "Enter") {
            const { input } = this.state;
            const { max, validator } = this.props;
            if (max !== undefined && this.props.tags.length >= max) {
                this.error(`Maximum of ${max} values allowed`);
                return;
            }
            if (validator !== undefined) {
                const valid = validator(input);
                if (valid !== null) {
                    this.error(valid);
                    return;
                }
            }
            const tags = [...this.props.tags];
            tags.push(input);
            this.props.onChange(tags);
            this.setState({ input: "" });
        }
    }
    onInputChange(e) {
        this.setState({ input: e.target.value });
    }
    remove(i) {
        const tags = [...this.props.tags];
        tags.splice(i, 1);
        this.props.onChange(tags);
    }
    error(e) {
        if (this.props.onError) {
            this.props.onError(e);
        }
    }
    render() {
        const { max, disabled } = this.props;
        const { tags, shadow, placeholder } = this.props;
        const { input } = this.state;
        const enabled = disabled === false || disabled === undefined || disabled === null;
        const maxTagsReached = max !== undefined ? tags.length >= max : false;
        return (React.createElement(Wrapper, { shadow: shadow },
            tags.map((tag, i) => (React.createElement(Tag, { key: i },
                React.createElement(TagLabel, { hasPaddingRight: !enabled }, tag),
                enabled &&
                    React.createElement(TagTimes, { onClick: () => this.remove(i) },
                        React.createElement(FaTimes, null))))),
            (enabled && !maxTagsReached) &&
                React.createElement(Input, { form: "doesnt-exists", placeholder: placeholder || "Type a value and press enter", value: input, onChange: this.onInputChange, onKeyPress: this.onEnter })));
    }
}
//# sourceMappingURL=index.js.map